import React, {useEffect, useState} from 'react'
import {BaseButton, Box, Button, Text, useDisclosure} from '../../../../vanilla'
import {useContentStore, useGlobalStore} from '../../../../store/hooks/useStore'
import {Link} from '../../../../components/link'
import {HelpFilledIcon} from '../../../../components/icons'
import {PreBookFAQModal, PreBookFAQModalContent} from './pre-book-faq-modal'

const PRE_BOOK_FAQ_SLOT = 'pre-book-faq'

export const PreBookBanner = () => {
  const [preBookDays, setPreBookDays] = useState<number>(0)
  const [preBookSeasonalName, setPreBookSeasonalName] = useState<string>('')
  const {getCustomSitePreferenceById, isCustomSitePreferenceSet, customSitePreferences} = useGlobalStore()
  const cms = useContentStore()
  const [preBookFAQSlot, setPreBookFAQSlot] = useState<PreBookFAQModalContent | null>(null)
  const faqModal = useDisclosure(false)

  useEffect(() => {
    (async function () {
      if (!isCustomSitePreferenceSet('preBookDays')) {
        await getCustomSitePreferenceById('preBookDays')
      }
      if (!isCustomSitePreferenceSet('preBookForNewCustomersEnabled')) {
        await getCustomSitePreferenceById('preBookForNewCustomersEnabled')
      }
      setPreBookDays(customSitePreferences['preBookDays'] as number)
      setPreBookSeasonalName(customSitePreferences['preBookSeasonalName'] as string)
    })()
  })

  useEffect(() => {
    (async function () {
      if (!cms.contentById[PRE_BOOK_FAQ_SLOT]) {
        await cms.fetchItemByKey(PRE_BOOK_FAQ_SLOT)
      }
      setPreBookFAQSlot(cms.contentById[PRE_BOOK_FAQ_SLOT])
    })()
  }, [])

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        backgroundColor="white"
        paddingX={["16px", "28px"]}
        paddingY="16px"
      >
        <Text variant="heading1">Pre-book {preBookSeasonalName} deliveries are now available</Text>
        <Text borderBottom="1px" borderColor="gray200" paddingBottom="4px" marginBottom="12px">
          Pre-book your delivery up to {preBookDays} days in advance
        </Text>
        <BaseButton
          size="sm"
          variant="primary"
          maxHeight="40px"
          alignSelf="flex-end"
          as={Link}
          href="/pre-book-delivery"
          data-test-selector="pre-book-now-button"
        >
          <Text variant="unstyled" fontSize="inherit" lineHeight="inherit" paddingX="20px">
            Pre-book Now
          </Text>
        </BaseButton>
      </Box>
      {preBookFAQSlot && preBookFAQSlot?.title && preBookFAQSlot?.bodyText ? (
        <>
          <Box display="flex" backgroundColor="white" paddingX={['16px', '28px']} paddingY="8px">
            <HelpFilledIcon width="16px" height="auto" color="accent3" />
            <Button
              variant="unstyled"
              height="auto"
              onClick={() => faqModal.onOpen()}
              cursor="pointer"
              data-test-selector="pre-book-faq-button"
            >
              <Text
                variant="text3"
                color={{default: 'accent3', hover: 'accent3Light'}}
                textDecoration="underline"
              >
                What are pre-book deliveries?{' '}
              </Text>
            </Button>
          </Box>
          {faqModal.isOpen && <PreBookFAQModal content={preBookFAQSlot} {...faqModal} />}
        </>
      ): null}
    </>
  )
}
